import { AppLanguage } from '@lmt/unicorn-shared/app/constants/languages';
import { setLanguageForLocale } from '@lmt/unicorn-shared/app/helpers/date-helper';
import Logger from 'js-logger';
import { initReactI18next, useTranslation } from 'react-i18next';
import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import sprintf from 'i18next-sprintf-postprocessor';
import LanguageDetector from 'i18next-browser-languagedetector';
import { APP_VERSION } from '../../constants/constants';
import { NS_DataBlockFields } from './useScopedTranslation';
import { useMemo } from 'react';

let i18nConfigurationStarted = false;
export function useConfigureI18n(
  configureTranslation?: (translation: typeof i18n) => void,
) {
  useMemo(() => {
    if (i18nConfigurationStarted) return;
    i18nConfigurationStarted = true;
    configurei18n(configureTranslation);
  }, []);

  useTranslation();
}

export const configurei18n = (
  configureTranslation?: (translation: typeof i18n) => void,
) => {
  const initPromise = i18n
    .use(LanguageDetector)
    .use(sprintf)
    .use(Backend)
    .use(initReactI18next)
    .init({
      backend: {
        loadPath: (lngs: string[], namespaces: string[]) => {
          const lng = lngs[0];
          const namespace = namespaces[0];
          if (namespace === 'translation') return `/translations/${lng}.json`;
          return `/translations/${namespace}.${lng}.json`;
        },
        queryStringParams: { v: APP_VERSION },
        crossDomain: true,
      },
      ns: ['translation', NS_DataBlockFields],
      supportedLngs: ['en', 'de', 'en-us'],
      lng: i18n.language,
      fallbackLng: 'en',
      returnObjects: true,
      load: 'languageOnly',
      lowerCaseLng: true,
      interpolation: {
        escapeValue: false, // not needed for react!!
      },
      react: {
        useSuspense: true,
      },
      detection: {
        caches: ['localStorage', 'cookie'], // cookie do not work in Electron
      },
      joinArrays: '\n',
    });
  if (configureTranslation) {
    configureTranslation(i18n);
  }
  return initPromise
    .then((x) => {
      setLanguageForLocale(i18n.language as AppLanguage);
    })
    .catch((e) => Logger.error(e));
};
